'use strict'

export function getPropertyIcon (prop) {
  // TODO обработать все типы полей
  switch (prop.type) {
    case 'boolean':
      return 'mdi-help'
    case 'integer':
    case 'double':
      return 'mdi-numeric'
    case 'listvalue':
      return 'mdi-format-list-bulleted-square'
    case 'list':
      return 'mdi-format-list-bulleted'
    case 'date':
      return 'mdi-calendar'
    case 'datetime':
    case 'duration':
      return 'mdi-calendar-clock'
    case 'object':
    case 'objects':
      return 'mdi-link-variant'
    case 'table':
      return 'mdi-table'
    case 'geopoint':
      return 'mdi-map-marker'
    case 'documents': // custom
      return 'mdi-file-outline'
    case 'string':
      return 'mdi-text-short'
    case 'multiline':
      return 'mdi-text'
    case 'valueChange':
      return 'mdi-swap-horizontal'
    case 'brigade':
      return 'mdi-account-hard-hat'
    case 'address':
      return 'mdi-map-marker'
    default:
      return null
  }
}

export function transformPropertyConfiguration (prop) {
  if (prop.type === 'listvalue') {
    const listvalues = []
    if (prop.listvalues && prop.listvalues.value) {
      const values = prop.listvalues.value
      const names = prop.listvalues.name
      for (let i = 0; i < values.length; i++) {
        listvalues.push({ name: names[i], value: values[i] })
      }
      listvalues.sort((obj1, obj2) => {
        return obj1.name.localeCompare(obj2.name, 'ru', {
          numeric: true
        })
      })
    }
    prop.listvalues = listvalues
  }
}
